/**
 * Iconografía propia, en línea.
 *
 * Sin librería externa ni CDN (DEC-A13): un juego pequeño de trazos SVG cubre
 * todas las necesidades y hereda el color del texto, lo que garantiza contraste
 * en ambos temas sin duplicar activos.
 */

export type IconName =
  | 'home'
  | 'dashboard'
  | 'people'
  | 'exchange'
  | 'rotation'
  | 'clock'
  | 'absence'
  | 'late'
  | 'overtime'
  | 'vacation'
  | 'document'
  | 'gavel'
  | 'clipboard'
  | 'alert'
  | 'sync'
  | 'user-cog'
  | 'shield'
  | 'history'
  | 'settings'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-down'
  | 'chevron-up'
  | 'search'
  | 'close'
  | 'check'
  | 'download'
  | 'refresh'
  | 'moon'
  | 'sun'
  | 'logout'
  | 'key'
  | 'eye'
  | 'eye-off'
  | 'plus'
  | 'edit'
  | 'trash'
  | 'filter'
  | 'info'
  | 'inbox'
  | 'cloud-off'
  | 'database-off'
  | 'play'
  | 'bell'
  | 'user';

const PATHS: Record<IconName, string> = {
  home: 'M3 10.5 12 3l9 7.5M5 9.5V21h14V9.5',
  dashboard: 'M3 3h8v8H3zM13 3h8v5h-8zM13 10h8v11h-8zM3 13h8v8H3z',
  people: 'M8 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM2 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5M16 11.5a3 3 0 1 0 0-6M17 14.6c2.9.4 5 2.4 5 5.4',
  exchange: 'M4 8h13l-3.5-3.5M20 16H7l3.5 3.5',
  rotation: 'M20 12a8 8 0 1 1-2.5-5.8M20 4v4h-4',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7.5V12l3.2 2',
  absence: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM3 20c0-3.3 2.7-5.5 6-5.5 1 0 2 .2 2.8.6M15 15.5h6M18 12.5v6',
  late: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7.5V12l4 2.4M4.5 4.5 3 3M19.5 4.5 21 3',
  overtime: 'M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17ZM12 8v4l3 1.8M17.5 17.5 21 21',
  vacation: 'M12 20V9M12 9c0-3.3 2.7-6 6-6-1 3.5-3 6-6 6ZM12 9C12 5.7 9.3 3 6 3c1 3.5 3 6 6 6ZM4 20h16',
  document: 'M14 3H7a1.5 1.5 0 0 0-1.5 1.5v15A1.5 1.5 0 0 0 7 21h10a1.5 1.5 0 0 0 1.5-1.5V7.5L14 3ZM13.5 3.2V8h4.8M9 12.5h6M9 16h6',
  gavel: 'M10.5 6 6 10.5m3-6.8 4.8 4.8M15 8.7l-4.8-4.8M4 20h9M12.8 9.7 18 15M16.2 13.2l3.3 3.3-2 2-3.3-3.3',
  clipboard:
    'M9 4.5H7.5A1.5 1.5 0 0 0 6 6v14a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 18 20V6a1.5 1.5 0 0 0-1.5-1.5H15M9 4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5v.8H9v-.8ZM9.5 13l2 2 3.5-4',
  alert: 'M12 4 2.8 20h18.4L12 4ZM12 10v4.5M12 17.2v.6',
  sync: 'M20.5 6.5v4h-4M3.5 17.5v-4h4M4 11a8 8 0 0 1 13.3-4M20 13a8 8 0 0 1-13.3 4',
  'user-cog': 'M9.5 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM3 20c0-3.3 2.9-5.5 6.5-5.5M18 14v1.2M18 20.8V22M15.4 15.6l.9.9M19.7 19.9l.9.9M14 18.5h1.2M20.8 18.5H22M15.4 21.4l.9-.9M19.7 17.1l.9-.9',
  shield: 'M12 3 5 6v6c0 4.2 3 7.5 7 9 4-1.5 7-4.8 7-9V6l-7-3ZM9 12.2l2.2 2.3L15.2 10',
  history: 'M3.5 12a8.5 8.5 0 1 0 3-6.5M3.5 4v4h4M12 8v4.3l3.2 1.9',
  settings:
    'M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4ZM19.4 13.5a7.6 7.6 0 0 0 0-3l1.8-1.2-1.8-3.1-2 .8a7.6 7.6 0 0 0-2.6-1.5L14.4 3H9.6l-.4 2.5A7.6 7.6 0 0 0 6.6 7l-2-.8-1.8 3.1 1.8 1.2a7.6 7.6 0 0 0 0 3l-1.8 1.2 1.8 3.1 2-.8a7.6 7.6 0 0 0 2.6 1.5L9.6 21h4.8l.4-2.5a7.6 7.6 0 0 0 2.6-1.5l2 .8 1.8-3.1-1.8-1.2Z',
  'chevron-left': 'M14.5 5 7.5 12l7 7',
  'chevron-right': 'M9.5 5l7 7-7 7',
  'chevron-down': 'M5 9.5l7 7 7-7',
  'chevron-up': 'M5 14.5l7-7 7 7',
  search: 'M10.5 17.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM15.6 15.6 21 21',
  close: 'M5.5 5.5 18.5 18.5M18.5 5.5 5.5 18.5',
  check: 'M4.5 12.5 9.5 17.5 19.5 6.5',
  download: 'M12 3.5v11M7.5 10.5 12 15l4.5-4.5M4 20h16',
  refresh: 'M20 11A8 8 0 0 0 6.3 6.3L3.5 9M4 13a8 8 0 0 0 13.7 4.7L20.5 15M3.5 4.5V9h4.5M20.5 19.5V15H16',
  moon: 'M20 14.5A8.5 8.5 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5Z',
  sun: 'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM12 2.5v2M12 19.5v2M2.5 12h2M19.5 12h2M5.2 5.2l1.4 1.4M17.4 17.4l1.4 1.4M18.8 5.2l-1.4 1.4M6.6 17.4l-1.4 1.4',
  logout: 'M14 8V5.5A1.5 1.5 0 0 0 12.5 4H5.5A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20h7a1.5 1.5 0 0 0 1.5-1.5V16M9.5 12H21M17.5 8.5 21 12l-3.5 3.5',
  key: 'M15.5 10.5a4 4 0 1 0-3.9-5L3 14.6V20h5.4l1.6-1.6v-2h2v-2h2l1.5-1.5a4 4 0 0 0 0-2.4ZM16.8 7.2h.01',
  eye: 'M12 5.5c-5 0-9 6.5-9 6.5s4 6.5 9 6.5 9-6.5 9-6.5-4-6.5-9-6.5ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  'eye-off': 'M4 4l16 16M9.9 5.9A9.5 9.5 0 0 1 12 5.5c5 0 9 6.5 9 6.5a17 17 0 0 1-3 3.7M6.2 8.3A17 17 0 0 0 3 12s4 6.5 9 6.5c.8 0 1.5-.1 2.2-.3M10 10a3 3 0 0 0 4 4',
  plus: 'M12 5v14M5 12h14',
  edit: 'M4 20h4L20 8l-4-4L4 16v4ZM14.5 5.5 18.5 9.5',
  trash: 'M4.5 7h15M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10.5 10.5v6M13.5 10.5v6',
  filter: 'M3.5 5.5h17l-6.5 8v6l-4-2v-4l-6.5-8Z',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 11v6M12 7.4v.6',
  inbox: 'M3.5 13.5 6 5.5h12l2.5 8v5h-17v-5ZM3.5 13.5H9l1 2h4l1-2h5.5',
  'cloud-off': 'M4 4l16 16M7.5 18.5h9M6.5 18.5a3.5 3.5 0 0 1-.6-6.9M9 7.2A5.5 5.5 0 0 1 17.5 12a3.5 3.5 0 0 1 1.6 6.3',
  'database-off': 'M4 4l16 16M4.5 6.5c0-1.4 3.4-2.5 7.5-2.5 1.6 0 3 .2 4.2.5M19.5 8.6v8.9c0 1.4-3.4 2.5-7.5 2.5s-7.5-1.1-7.5-2.5V10M4.5 13c0 1.4 3.4 2.5 7.5 2.5',
  play: 'M7.5 4.5 19 12 7.5 19.5v-15Z',
  bell: 'M18 15.5V11a6 6 0 1 0-12 0v4.5L4.5 18h15L18 15.5ZM9.8 20.5a2.4 2.4 0 0 0 4.4 0',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20.5c0-3.6 3.3-6 7.5-6s7.5 2.4 7.5 6',
};

export interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
  /** Los iconos son decorativos por defecto; con `title` pasan a ser accesibles. */
  title?: string;
}

export function Icon({ name, size = 16, className, title }: IconProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={title === undefined}
      role={title === undefined ? undefined : 'img'}
      focusable="false"
    >
      {title !== undefined && <title>{title}</title>}
      <path d={PATHS[name]} />
    </svg>
  );
}
